import React from 'react';
import { IUseFilteredAnnouncementsParams, useFilteredAnnouncements } from 'containers/Announcements/hooks/useFilteredAnnouncements';
import { AnnouncementsDisplayRender } from './AnnouncementsDisplayRender';

export interface IAnnouncementsDisplayProps extends IUseFilteredAnnouncementsParams {
  className?: string;
  maxInitialDisplay?: number; // Default 3
}

/**
 * Reusable component to display announcements with show more/less functionality.
 * Fetches and filters announcements based on provided parameters, then displays them
 * using the AnnouncementsDisplayRender presentational component.
 * Shows max 3 titles initially, with "Show more" to expand and show all titles + descriptions.
 */
export const AnnouncementsDisplay: React.FC<IAnnouncementsDisplayProps> = ({
  hotelUuid,
  checkInDate,
  checkOutDate,
  appearIn,
  enabled = true,
  className,
  maxInitialDisplay = 3,
}) => {
  const queryResult = useFilteredAnnouncements({
    hotelUuid,
    checkInDate,
    checkOutDate,
    appearIn,
    enabled,
  });

  const announcements = queryResult.data?.data ?? [];

  return (
    <AnnouncementsDisplayRender
      announcements={announcements}
      className={className}
      maxInitialDisplay={maxInitialDisplay}
    />
  );
};

